import { useGetOnboardingStatusQuery } from 'store/api/customer.apislice';
import { useGetCurrentSubscriptionQuery } from 'store/api/subscription.apislice';
import { useNavigate } from 'react-router-dom';
import ROUTES from 'router/routes.constants';
import toast from 'react-hot-toast';

export const usePlanGate = () => {
  const navigate = useNavigate();
  const { data: onboardingData } = useGetOnboardingStatusQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const { data: currentSubscription } = useGetCurrentSubscriptionQuery();

  const customerType = onboardingData?.data?.customerType || onboardingData?.data?.customer_type;
  const isSubscriptionActive = currentSubscription?.result?.status === 'ACTIVE';

  const isPlanDisabled = !customerType || (customerType === 'DIRECT' && !isSubscriptionActive);

  const requirePlanSelection = (skipKyc = false) => {
    // 1. Plan selection check
    if (!customerType) {
      window.dispatchEvent(new Event('open-plan-selection-modal'));
      return true;
    }

    // 2. KYC / Onboarding check
    if (!skipKyc) {
      const isOnboardingCompleted =
        onboardingData?.isOnboardingCompleted === true ||
        onboardingData?.data?.isOnboardingCompleted === true;

      const isUCCOnboardingCompleted =
        onboardingData?.isUCCOnboardingCompleted === true ||
        onboardingData?.data?.isUCCOnboardingCompleted === true;

      const onboardingDone = isOnboardingCompleted && isUCCOnboardingCompleted;

      if (!onboardingDone) {
        navigate(ROUTES.ONBOARDING_STATUS);
        toast.error("Please complete your onboarding details first.");
        return true;
      }
    }

    // 3. Direct Plan specific checks (Agreement check)
    if (customerType === 'DIRECT') {
      if (!isSubscriptionActive) {
        window.dispatchEvent(new Event('open-plan-selection-modal'));
        return true;
      }

      const agreementCompleted = 
        onboardingData?.agreement?.completed || 
        onboardingData?.data?.agreement?.completed;

      if (!agreementCompleted) {
        window.dispatchEvent(new Event('open-agreement-modal'));
        return true;
      }
    }

    // Risk Profiling is skipped for Bonds, Smart Borrowing, and Consent flows
    return false;
  };

  return { isPlanDisabled, requirePlanSelection };
};


